import { CURRENCY_LIST_OPTIONS, Select, TextField, convertToOptions } from 'vopay';
import { useState, FunctionComponent, useEffect } from 'react';
import styles from './SubAccount.module.scss';
import { Button } from '@/components/UI';
import { useTranslation } from 'react-i18next';

export type SubAccountStatus = 'Active' | 'NotActive' | '';

type ReportsSearchParams = {
  status: SubAccountStatus;
  searchTerm: string;
  currency: string;
  country: string;
};

type SearchFormProps = {
  status: SubAccountStatus;
  currency: string;
  country: string;
  searchTerm: string;
  countries: string[];
  search: (searchParams: ReportsSearchParams) => void;
};

type FC = FunctionComponent<SearchFormProps>;

const SubAccountSearchForm: FC = (props: SearchFormProps) => {
  const { status, currency, country, searchTerm, countries, search } = props;
  const [currentStatus, setCurrentStatus] = useState<SubAccountStatus>(status);
  const [currentCurrency, setCurrentCurrency] = useState<string>(currency);
  const [currentCountry, setCurrentCountry] = useState<string>(country);
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>(searchTerm);
  const { t } = useTranslation('translations', { keyPrefix: 'SubAccounts.List.SearchForm' });

  useEffect(() => {
    setCurrentSearchTerm(searchTerm);
  }, [searchTerm]);
  useEffect(() => {
    setCurrentStatus(status);
  }, [status]);
  useEffect(() => {
    setCurrentCurrency(currency);
  }, [currency]);
  useEffect(() => {
    setCurrentCountry(country);
  }, [country]);

  const statusOptions: Record<Exclude<SubAccountStatus, ''>, string> = {
    Active: t('Status.Options.active'),
    NotActive: t('Status.Options.notActive'),
  };

  const currencyOptions = {
    ...CURRENCY_LIST_OPTIONS,
    EUR: 'EUR',
    GBP: 'GBP',
  };

  const countryOptions = {
    ...countries.reduce((acc, country) => ({ ...acc, [country]: country }), {}),
  };

  return (
    <div className={styles.searchArea}>
      <Select
        version="2"
        placeholder={t('Country.placeholder')}
        options={convertToOptions(countryOptions)}
        name="country"
        value={currentCountry}
        onBlur={() => {}}
        showClear
        onChange={(e) => {
          setCurrentCountry(e.target.value);
        }}
        sort={false}
      />
      <Select
        version="2"
        placeholder={t('Currency.placeholder')}
        options={convertToOptions(currencyOptions)}
        name="currency"
        value={currentCurrency}
        showClear
        onBlur={() => {}}
        onChange={(e) => {
          setCurrentCurrency(e.target.value);
        }}
        sort={false}
      />

      <Select
        version="2"
        placeholder={t('Status.placeholder')}
        options={convertToOptions(statusOptions)}
        name="status"
        sort={false}
        showClear
        value={currentStatus}
        onBlur={() => {}}
        onChange={(e) => {
          setCurrentStatus(e.target.value as SubAccountStatus);
        }}
      />
      <TextField
        key="AccountSearchKeyword"
        name="AccountSearchKeyword"
        placeholder={t('keywordPlaceholder')}
        value={currentSearchTerm}
        onBlur={() => {}}
        onChange={(e) => {
          setCurrentSearchTerm(e.target.value);
        }}
        variant="outlineShadow"
        width="100%"
      />

      <Button
        id="search-elinx"
        colorScheme="primary"
        onClick={() =>
          search({
            status: currentStatus,
            currency: currentCurrency,
            country: currentCountry,
            searchTerm: currentSearchTerm,
          })
        }
      >
        {t('searchButtonLabel')}
      </Button>
    </div>
  );
};

export default SubAccountSearchForm;
